/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { AxiosRequestConfig } from 'axios';
import { api, extractResponse } from '@utils/network';
import {
  ValidateUrlsRequestParams,
  SocialFlowResponse,
  CompleteSocialLinkingData,
  SocialLinkingProcess,
  CancelSocialLinkingData
} from './types';

export const Request = {
  startSocialLinking: (config?: AxiosRequestConfig): Promise<SocialLinkingProcess> =>
    extractResponse<SocialLinkingProcess>(api.post('/social/linking', undefined, config)),
  completeSocialLinking: (
    linkingId: string,
    data: CompleteSocialLinkingData,
    config?: AxiosRequestConfig
  ): Promise<SocialLinkingProcess> =>
    extractResponse<SocialLinkingProcess>(api.post(`/social/linking/${linkingId}`, data, config)),
  cancelSocialLinking: (linkingId: string, data: CancelSocialLinkingData, config?: AxiosRequestConfig): Promise<void> =>
    extractResponse<void>(api.post(`/social/linking/${linkingId}/cancel`, data, config)),
  getSocialFlow: (flowId: string, config?: AxiosRequestConfig): Promise<SocialFlowResponse> =>
    extractResponse<SocialFlowResponse>(api.get(`/social/${flowId}`)),
  unlink: (linkId: string, config?: AxiosRequestConfig): Promise<void> =>
    api.delete(`/social/unlink/${linkId}`, config),
  validate: (body: ValidateUrlsRequestParams, config?: AxiosRequestConfig): Promise<void> =>
    extractResponse<void>(api.post('/social/validate', body, config))
};
